export default windowObject => {
  window.appReady = true
  windowObject.appReady = true
}
